module.exports = __webpack_public_path__ + "media/applications/assets/images/materials/classic-tee/23-c3980a18bfde185ff7d177bb018629f3.jpg";